var path = 'areas/environments/views/endpoints/tentacle_active_endpoint.html';
var html = "<div> <control-group label=Thumbprint> <input id=thumbprint class=\"thumbprint form-control\" type=text ng-model=endpoint.Thumbprint> <p class=help-block> The X509 certificate thumbprint that securely identifies the machine. You can confirm the validity of the thumbprint by opening the Tentacle administration tool on the discovered machine. </p> <p class=padding-sm-vr> Please ensure the Tentacle is configured to trust an Octopus Server with the thumbprint: <span class=thumbprint>{{ serverThumbprint }}</span> </p> </control-group> </div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./app/areas/environments/views/endpoints/tentacle_active_endpoint.html
// module id = 789
// module chunks = 1